import React from 'react';
import { InternalLink } from '../utils/link';
import { translate } from '../utils/translate';

export const Breadcrumbs = ({ breadcrumbs }: { breadcrumbs: { url: string; title: string }[] }) =>
  breadcrumbs.length > 0 ? (
    <nav className="breadcrumbs" aria-label={translate('a11y:breadcrumbs')}>
      <div className="breadcrumbs__inner ls-container ls-gutter">
        <ol className="breadcrumbs__list">
          {breadcrumbs.map(
            (breadcrumb, index) =>
              breadcrumb.title && (
                <li
                  key={index}
                  className="breadcrumbs__item"
                  aria-current={index == breadcrumbs.length - 1 ? 'page' : undefined}
                >
                  <InternalLink url={breadcrumb.url} className="breadcrumbs__link">
                    <span className="breadcrumbs__label text--sm">{breadcrumb.title}</span>
                  </InternalLink>
                </li>
              )
          )}
        </ol>
      </div>
    </nav>
  ) : (
    <></>
  )
